import React from 'react';
import { Twitter, Facebook, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo />
            </div>
            <p>Empowering believers to connect, share, and grow in a safe digital environment.</p>
            <div className="social-links">
              <a href="/" aria-label="Twitter"><Twitter size={20} /></a>
              <a href="/" aria-label="Facebook"><Facebook size={20} /></a>
              <a href="/" aria-label="Instagram"><Instagram size={20} /></a>
              <a href="/" aria-label="LinkedIn"><Linkedin size={20} /></a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-col">
              <h4>Platform</h4>
              <a href="/">Features</a>
              <a href="/">Safety</a>
              <a href="/">Community Guidelines</a>
              <a href="/">Download</a>
            </div>
            <div className="footer-col">
              <h4>Company</h4>
              <a href="/">About Us</a>
              <a href="/">Our Mission</a>
              <a href="/">Careers</a>
              <a href="/">Contact</a>
            </div>
            <div className="footer-col">
              <h4>Legal</h4>
              <a href="/">Privacy Policy</a>
              <a href="/">Terms of Service</a>
              <a href="/">Cookie Policy</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            &copy; {new Date().getFullYear()} Faith Connect. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
